import './App.css'
import React from 'react';
import { Router } from 'react-router-dom';
import history from './history';
import { Container } from 'react-bootstrap';
import { renderRoutes } from 'react-router-config';
import { WebSocketProvider } from 'hooks/webSocketContext';
import { ScrollReset, GoogleAnalytics } from './components';
import routes from './routes';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './assets/scss/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/theme.css';
import './assets/css/modern-data-table.css';
import { ThemeProvider } from './contexts/ThemeContext';

const App = () => {
  return (
    <ThemeProvider>
      <WebSocketProvider>
        <Router history={history}>
          <ScrollReset />
          <GoogleAnalytics />
          <Container fluid className="p-0">
            {renderRoutes(routes)}
          </Container>
        </Router>
      </WebSocketProvider>
    </ThemeProvider>
  );
};

export default App;
